import { getZoneDetails } from './HomeUtil'
import { getProductData } from './Utils'

const gaSy25EventHistory = []

const isEventInHistory = (eventName, stepName, subStepName) => 
  gaSy25EventHistory.some(el => (el.eventName === eventName) && (el.stepName === stepName) && (el.subStepName === subStepName))

const addEventToHistory = (eventName, stepName, subStepName) => {
  gaSy25EventHistory.push({ eventName, stepName, subStepName })
}

export const gaPageLoad  = (product, payload) => {

  const { designGuid } = payload
  
  if (window.jostensGaTracking) {
    if (isEventInHistory('gaPageLoad', null, null)) { return; }
    const productData = getProductData()
    if (!designGuid) {  // disable GA tracking when editting
      window.jostensGaTracking.init({
          customerId: window.jostens.customer.number,
          gaPageType: window.jostensGaTracking.gaPageTypeList.productDetailPage,
          publishedCatalogId: productData?.publishedCatalogId,
          publishedProductId: productData?.publishedProductId,
          sourceCatalogType: productData?.sourceCatalogType
      })
    }
    window.jostensGaTracking.trackEvent({
        event: window.jostensGaTracking.gaEventNameList.productDetailPage.designerPageLoad,
        client: {
            designerTotalSteps: 4,
            selectedProducts: [{
              osr: productData?.productOsr,
              name: productData?.displayName,
              productType: productData?.productType,
              price: payload?.estimatedPrice || productData?.configuredPrice,
              quantity: 1
            }]
        },
        product: {
            configuredPrice: parsePrice(payload?.estimatedPrice || productData?.configuredPrice)
        }
    })
    addEventToHistory('gaPageLoad', null, null)

  } else {
    const Productinfo = [];
    for (let datakey in product) {
      Productinfo.push({
        id: product[datakey].payload.product.id,
        name: product[datakey].payload.product.name,
        category: product[datakey].payload.product.prodType,
      });
    }

    window.dataLayer && window.dataLayer.push({
      "event": "designerPageLoad",
      "pageType": "Product Detail Page:Stole Designer",
      "schoolType": window.jostens.customer.routerType,
      "schoolId": window.jostens.customer.number,
      "schoolName": window.jostens.customer.extendedName,
      "designerProductCategory": product.enhanced.payload.product.prodType,
      "designerOrderStepName":"Designer Viewed",
      "designerType": "Stole",
      "ecommerce": {
        "detail": {
          "actionField": {
            "list": "Product Detail Page:Stole Designer",
          },
          "products":Productinfo
        },
      },
    });
  }
};

const parsePrice = price => parseFloat((price || 0).toFixed(2))

const getStepName = (stepIndex, stoleMeta) => stoleMeta?.stepper?.[`step${stepIndex + 1}`] || ''

const STEPS = {
  STOLE_DESIGN: 0,
  SCHOOL_BRANDING: 1,
  YOUR_STOLE: 2,
  REVIEW_ORDER: 3
}

const SCHOOL_BRANDING_SUB_STEPS = [ 'BaseColor', 'TrimColor', 'FontThread', 'TipMaterial' ]

const getSubStepName = (currentStep, substemNameBranding, stoleMeta, selectedTemplate, selectedStage) => {
  switch (currentStep) {
    case STEPS.STOLE_DESIGN:
      return stoleMeta?.configContainer?.bodyTitle || '';
    case STEPS.SCHOOL_BRANDING:
      return stoleMeta?.branding?.[substemNameBranding]?.tabTitle || ''
    case STEPS.YOUR_STOLE:
      const currentZone = getZoneDetails(selectedTemplate, selectedStage)
      return currentZone?.zoneName || '';
    case STEPS.REVIEW_ORDER:
      return 'Review & Order'
    default:
      return ''
  }
}

const getSubStepNumber = (currentStep, substemNameBranding, selectedTemplate, selectedStage) => {
  switch (currentStep) {
    case STEPS.STOLE_DESIGN:
      return 1
    case STEPS.SCHOOL_BRANDING:
      return SCHOOL_BRANDING_SUB_STEPS.map(el => el.toUpperCase()).indexOf(substemNameBranding?.toUpperCase()) + 1
    case STEPS.YOUR_STOLE:
      const currentZone = getZoneDetails(selectedTemplate, selectedStage)
      const subStepNumber = selectedTemplate?.zones?.findIndex(el => (currentZone?.zoneCode) && (el.zoneCode === currentZone?.zoneCode))
      return subStepNumber + 1;
    case STEPS.REVIEW_ORDER:
        return 1
    default:
      return -1
  }
}

const getSelectedProduct = (selectedTemplate, estimatedPrice) => {
  const productData = getProductData()
  return ((productData?.productOsr) && (selectedTemplate?.product)) ? {
      osr: productData?.productOsr,
      name: productData?.displayName,
      productType: productData?.productType,
      price: estimatedPrice || selectedTemplate?.product.configPrice,
      quantity: 1
  } : null
}

export const gaDesignerSubstep = (currentStep,
  selectedStage,setSelectedStage,selectedTemplate,substemNameBranding,brandingTab,estimatedPrice,stoleMeta) => {
    
    if (window.jostensGaTracking) {
      const stepName = getStepName(currentStep, stoleMeta)
      const subStepName = getSubStepName(currentStep, substemNameBranding, stoleMeta, selectedTemplate, selectedStage)
      if (isEventInHistory('gaDesignerSubstep', stepName, subStepName)) { return; }
      window.jostensGaTracking.trackEvent({
          event: window.jostensGaTracking.gaEventNameList.productDetailPage.designerSubStepComplete,
          client: {
              designerSubStepName: subStepName, 
              designerSubStepNumber: getSubStepNumber(currentStep, substemNameBranding, selectedTemplate, selectedStage),
              designerStepName: stepName,
              designerStepNumber: parseInt(currentStep + 1), 
              designerTotalSteps: 4,
              selectedProducts: [ getSelectedProduct(selectedTemplate, estimatedPrice) ]
          },
          product: {
              configuredPrice: parsePrice(estimatedPrice)
          }
      })
      addEventToHistory('gaDesignerSubstep', stepName, subStepName)
    } else {
      if (currentStep >= 2) selectedStage = 'Your Stole'
      window.dataLayer && window.dataLayer.push({
      "event": "designerSubStepComplete",
      "pageType": "Product Detail Page:Stole Designer",
      "schoolType": window.jostens.customer.routerType,
      "schoolId":window.jostens.customer.number,
      "schoolName":window.jostens.customer.extendedName,
      "designerProductSku":selectedTemplate.product.id,
      "designerProductCategory":selectedTemplate.product.prodType,
      "designerType": "Stole",
      "designerOrderStepName": "Designer Viewed",
      "designerStepName": selectedStage,
      "designerStepNumber": currentStep+1,
      "designerTotalSteps": 3,
      "designerSubStepName": substemNameBranding,
      "designerSubStepNumber":brandingTab+1,
    // "stepModification": "true",
    });
  }
};

export const gaEmptyPositionPopup = (setSelectedStage,
  selectedStage,selectedTemplate,setsubstemNameZone,brandingTab) => {
    if (!window.jostensGaTracking) {  // event not covered when GASY25 is enabled
      selectedStage = 'Your Stole'
      window.dataLayer && window.dataLayer.push({
      "event": "emptyPositionPopup",
      "pageType": "Product Detail Page:Stole Designer",
      "schoolType": window.jostens.customer.routerType,
      "schoolId": window.jostens.customer.number,
      "schoolName": window.jostens.customer.extendedName,
      "designerProductSku":selectedTemplate.product.id,
      "designerProductCategory":selectedTemplate.product.prodType,
      "designerType": "Stole",
      "designerOrderStepName": "Designer Viewed",
      "designerStepNumber":setSelectedStage,
      "designerStepName": selectedStage,
      "designerTotalSteps": 3,
      "designerSubStepName": setsubstemNameZone,
      "designerSubStepNumber":brandingTab+1,
    });
  }
};

export const gaEmptyPositionPopupInside = (
  currentStep,
  selectedStage,
  returnorcontinue,
  selectedTemplate,
  setsubstemNameZone
) => {
  if (!window.jostensGaTracking) {  // event not covered when GASY25 is enabled
    if (currentStep >= 2) selectedStage = 'Your Stole'
    window.dataLayer && window.dataLayer.push({
      "event": "emptyPositionPopupClick",
      "pageType": "Product Detail Page:Stole Designer",
      "schoolType": window.jostens.customer.routerType,
      "schoolId": window.jostens.customer.number,
      "schoolName": window.jostens.customer.extendedName,
      "designerProductSku": selectedTemplate.product.id,
      "designerProductCategory": selectedTemplate.product.prodType,
      "designerType": "Stole",
      "designerOrderStepName": "Designer Viewed",
      "designerStepName": "Your Stole",
      "designerStepNumber":3,
      "designerTotalSteps": 3,
      "designerSubStepName": setsubstemNameZone,
      "designerSubStepNumber":currentStep,
      "stolePopupClick":  returnorcontinue,
    });
  }
};

export const gaSaveDesignInitiated = (
    currentStep,
    selectedStage,
    selectedTemplate,
    substemNameBranding,
    brandingTab,
    estimatedPrice,
    stoleMeta
  ) => {
    if (window.jostensGaTracking) {
      const stepName = getStepName(currentStep, stoleMeta)
      const subStepName = getSubStepName(currentStep, substemNameBranding, stoleMeta, selectedTemplate, selectedStage)
      window.jostensGaTracking.trackEvent({
          event: window.jostensGaTracking.gaEventNameList.productDetailPage.saveDesignInitiated,
          client: {
              designerSubStepName: subStepName, 
              designerSubStepNumber: getSubStepNumber(currentStep, substemNameBranding, selectedTemplate, selectedStage),
              designerStepName: stepName, 
              designerStepNumber: parseInt(currentStep + 1), 
              designerTotalSteps: 4,
              selectedProducts: [ getSelectedProduct(selectedTemplate, estimatedPrice) ]
          },
          product: {
              configuredPrice: parsePrice(estimatedPrice)
          }
      })
    } else {
      if(currentStep === 2) selectedStage = 'Your Stole'
    }
}

export const gaSaveDesignComplete
  = (
    currentStep,
    selectedStage,
    selectedTemplate,
    substemNameBranding,
    brandingTab,
    estimatedPrice,
    stoleMeta
  ) => {
  if (window.jostensGaTracking) {
    const stepName = getStepName(currentStep, stoleMeta)
    const subStepName = getSubStepName(currentStep, substemNameBranding, stoleMeta, selectedTemplate, selectedStage)
    window.jostensGaTracking.trackEvent({
        event: window.jostensGaTracking.gaEventNameList.productDetailPage.saveDesignComplete,
        client: {
            designerSubStepName: subStepName, 
            designerSubStepNumber: getSubStepNumber(currentStep, substemNameBranding, selectedTemplate, selectedStage),
            designerStepName: stepName, 
            designerStepNumber: parseInt(currentStep + 1), 
            designerTotalSteps: 4,
            selectedProducts: [ getSelectedProduct(selectedTemplate, estimatedPrice) ]
        },
        product: {
            configuredPrice: parsePrice(estimatedPrice)
        }
    })
  } else {
    if(currentStep === 2) selectedStage = 'Your Stole'
    
    const designerStepNumber = (currentStep === 3)
    ? 'Review' 
    : (currentStep + 1)

    window.dataLayer && window.dataLayer.push({
      "event": "savedDesignComplete",
      "pageType": "Product Detail Page:Stole Designer",
      "schoolType": window.jostens.customer.routerType,
      "schoolId": window.jostens.customer.number,
      "schoolName": window.jostens.customer.extendedName,
      "designerProductSku":selectedTemplate.product.id,
      "designerProductCategory":selectedTemplate.product.prodType,
      "designerType": "Stole",
      "designerOrderStepName": "Designer Viewed",
      "designerStepName": selectedStage,
      "designerStepNumber": designerStepNumber,
      "designerTotalSteps": 3,
    });
  }
};

export const gaDesignerStepComplete = (
  currentStep,
  selectedStage,
  selectedTemplate,
  substemNameBranding,
  brandingTab,
  estimatedPrice,
  stoleMeta
) => {
  if (window.jostensGaTracking) {
    const stepName = getStepName(currentStep, stoleMeta)
    const subStepName = getSubStepName(currentStep, substemNameBranding, stoleMeta, selectedTemplate, selectedStage)
    if (isEventInHistory('gaDesignerStepComplete', stepName, null)) { return; }
    window.jostensGaTracking.trackEvent({
        event: window.jostensGaTracking.gaEventNameList.productDetailPage.designerStepComplete,
        client: {
            designerSubStepName: subStepName, 
            designerSubStepNumber: getSubStepNumber(currentStep, substemNameBranding, selectedTemplate, selectedStage),
            designerStepName: stepName, 
            designerStepNumber: parseInt(currentStep + 1), 
            designerTotalSteps: 4,
            selectedProducts: [ getSelectedProduct(selectedTemplate, estimatedPrice) ]
        },
        product: {
            configuredPrice: parsePrice(estimatedPrice)
        }
    })
    addEventToHistory('gaDesignerStepComplete', stepName, null)
  } else {
    if (currentStep >= 2) selectedStage = 'Your Stole'
    window.dataLayer && window.dataLayer.push({
      'event': 'designerStepComplete',
      'pageType': 'Product Detail Page:Stole Designer',
      'schoolType': window.jostens.customer.routerType,
      'schoolId': window.jostens.customer.number,
      'schoolName': window.jostens.customer.extendedName,
      'designerType':'Stole',
      'designerOrderStepName':'Designer Viewed',
      'designerProductSku':selectedTemplate.product.id,
      'designerProductCategory':selectedTemplate.product.prodType,
      'designerStepName': selectedStage,
      'designerStepNumber': currentStep + 1,
      'designerTotalSteps': 3,
      //'subStepModification':'true'
    })
  }
}

export const gaDesignerComplete = (currentStep, selectedTemplate, substemNameBranding, brandingTab, selectedStage, estimatedPrice, stoleMeta) => { 
  if (window.jostensGaTracking) {
    const stepName = getStepName(currentStep, stoleMeta)
    const subStepName = getSubStepName(currentStep, substemNameBranding, stoleMeta, selectedTemplate, selectedStage)
    if (isEventInHistory('gaDesignerComplete', null, null)) { return; }
    window.jostensGaTracking.trackEvent({
        event: window.jostensGaTracking.gaEventNameList.productDetailPage.designerComplete, 
        client: {
            designerSubStepName: subStepName, 
            designerSubStepNumber: getSubStepNumber(currentStep, substemNameBranding, selectedTemplate, selectedStage),
            designerStepName: stepName,
            designerStepNumber: parseInt(currentStep + 1), 
            designerTotalSteps: 4,
            selectedProducts: [ getSelectedProduct(selectedTemplate, estimatedPrice) ]
        },
        product: {
            configuredPrice: parsePrice(estimatedPrice)
        }
    })
    addEventToHistory('gaDesignerComplete', null, null)
  } else {
    window.dataLayer && window.dataLayer.push({
      'event': 'designerComplete',
      'pageType': 'Product Detail Page:Stole Designer',
      'schoolType': window.jostens.customer.routerType,
      'schoolId': window.jostens.customer.number,
      'schoolName': window.jostens.customer.extendedName,
      'designerType': 'Stole',
      'designerOrderStepName': 'Designer Complete',
      'designerProductSku': selectedTemplate.product.id,
      'designerProductCategory': selectedTemplate.product.prodType,
      //'stepModification':'true'
    })
  }
}

export const gaAddToCart = (currentStep, selectedTemplate, substemNameBranding, brandingTab, selectedStage, estimatedPrice, stoleMeta) => {
  if (window.jostensGaTracking) {
    const stepName = getStepName(currentStep, stoleMeta)
    const subStepName = getSubStepName(currentStep, substemNameBranding, stoleMeta, selectedTemplate, selectedStage)
    if (isEventInHistory('gaAddToCart', null, null)) { return; }
    window.jostensGaTracking.trackEvent({
        event: window.jostensGaTracking.gaEventNameList.productDetailPage.addToCart,
        client: {
            designerSubStepName: subStepName, 
            designerSubStepNumber: getSubStepNumber(currentStep, substemNameBranding, selectedTemplate, selectedStage),
            designerStepName: stepName, 
            designerStepNumber: parseInt(currentStep + 1), 
            designerTotalSteps: 4,
            selectedProducts: [ getSelectedProduct(selectedTemplate, estimatedPrice) ]
        },
        product: {
            configuredPrice: parsePrice(estimatedPrice)
        }
    })
    addEventToHistory('gaAddToCart', null, null)
  } else {
    window.dataLayer && window.dataLayer.push({
      'event': 'addToCart',
      'pageType': 'Product Detail Page:Stole Designer',
      'schoolType': window.jostens.customer.routerType,
      'schoolId': window.jostens.customer.number,
      'schoolName':window.jostens.customer.extendedName,
      'designerType': 'Stole',
      'designerOrderStepName': 'Add to Cart',
      'designerProductSku': selectedTemplate.product.id,
      'designerProductCategory': selectedTemplate.product.prodType,
      'ecommerce': {
        'add': {
          'products': [
            {
              'id': selectedTemplate.product.id,
              'name': selectedTemplate.product.templateVariant,
              'category': selectedTemplate.product.prodType,
              'price': (selectedTemplate.product.configPrice+selectedTemplate.designSettings.data.upchargeAmt).toFixed(2),
              'quantity':1,
              'dimension49': window.jostens.customer.routerType,
              'dimension50': window.jostens.customer.number,
              'dimension60': window.jostens.customer.extendedName
            },
          ],
        },
      },
    })
  }
}